import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-117c17d9")

_pushScopeId("data-v-117c17d9")
const _hoisted_1 = { class: "input-border first" }
const _hoisted_2 = { class: "select-container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Skupiny uživatelů", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { style: {"height":"auto"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_detect_click = _resolveDirective("detect-click")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("div", {
        class: "group",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleInput()))
      }, [
        _createVNode("div", {
          class: ["wrap", { clearEdge : _ctx.visible }]
        }, [
          _createVNode("div", {
            class: ["input", { edge : _ctx.visible }]
          }, [
            (_ctx.promocodeConsumerGroup !== null)
              ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.getConsumerGroupName(_ctx.consumerGroups, _ctx.promocodeConsumerGroup)), 1))
              : _createCommentVNode("", true),
            (_ctx.promocodeConsumerGroup === null)
              ? (_openBlock(), _createBlock("span", _hoisted_5, "- vyberte skupinu uživatelů -"))
              : _createCommentVNode("", true)
          ], 2)
        ], 2),
        _createVNode("div", {
          class: ["arrow", { dropped : _ctx.visible }]
        }, null, 2),
        _createVNode("div", {
          class: { hidden : !_ctx.visible, visible: _ctx.visible }
        }, [
          _createVNode("ul", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.consumerGroups, (consumerGroup, index) => {
              return (_openBlock(), _createBlock("li", {
                class: { lastLi : (_ctx.consumerGroups.length-1) === index , current : consumerGroup.id === _ctx.promocodeConsumerGroup },
                key: consumerGroup.id,
                onClick: ($event: any) => (_ctx.$emit('apply-employee-configuration', consumerGroup.id))
              }, _toDisplayString(consumerGroup.name), 11, ["onClick"]))
            }), 128))
          ])
        ], 2)
      ], 512), [
        [_directive_detect_click, _ctx.toggleInputOutside]
      ])
    ])
  ]))
})